import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EditCMSPageNew from "../../components/CMS/AddCMSPageNew";



const EditCMSPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="CMS" link2="/cms" title="Edit CMS" />

        {/* AddUserLayer */}
        <EditCMSPageNew />


      </MasterLayout>
    </>
  );
};

export default EditCMSPage;
